export default {
  header: 'Musimy zweryfikować Twój numer telefonu',
  remember_device: {
    label: 'Zapamiętaj to urządzenie na {{days}} dni',
  },
  buttons: {
    confirm: 'Potwierdź',
  },
  toasts: {
    invalid_code: 'Nieprawidłowy kod. Spróbuj ponownie.',
  },
};
